module.exports = __webpack_public_path__ + "static/media/financial-skills-large@2x.677b7a4f.png";